import Store from 'store/store';
import { accessNested } from 'utils/utils';

function $(selector) { return document.querySelector(selector); }

let resizeObserver, cookieHeight;

if (typeof window !== 'undefined' && window.ResizeObserver) {
	if (window.ResizeObserver) {
		resizeObserver = new ResizeObserver(entries => {
			cookieHeight = entries[0].contentRect.height;
			updateCookieBanner(cookieHeight);
		});
	}
	lookForCookieBanner();
}

function lookForCookieBanner() {
	let start = Date.now();
	let check = () => {
		if ($('#_evidon_banner') && $('#_evidon_banner').offsetHeight) {
			if (resizeObserver) {
				return resizeObserver.observe($('#_evidon_banner'));
			}

			return setTimeout(() => updateCookieBanner($('#_evidon_banner').offsetHeight), 800);
		}
		// After 20 seconds, give up
		if (Date.now() - start < 20000) {
			setTimeout(check, 100);
		}
	};
	check();
}

function updateCookieBanner(height) {
	const store = Store.get();
	const evidonMode = accessNested(store, 'appData.options.requireUserConsent.position', '');
	
	if (evidonMode !== 'pushdown') {
		return;
	}

	if ($('#_evidon_banner')) {
		const evidonContainer = document.createElement('div');
		evidonContainer.style.position = 'fixed';
		evidonContainer.style.top = 0;
		evidonContainer.style.width = '100%';
		evidonContainer.style.zIndex = 2147000001;
		document.body.insertBefore(evidonContainer, document.body.firstChild);
		evidonContainer.appendChild($('#_evidon_banner'));
	}

	Store.get().set({
		evidon: {
			bannerOpen: height > 0,
			height: height
		}
	});
}

